import amapi from '@/api/amapi'

const initialState = () => ({
  invoiceLoading: false,
  error: null,
})

const state = initialState

const getters = {
  invoiceLoading: state => state.invoiceLoading,
  error: state => state.error,
}

const mutations = {
  SET_INVOICE_LOADING (state, val) {
    state.invoiceLoading = val
  },
  SET_ERROR (state, err) {
    state.error = err
  },
  RESET_STATE (state) {
    Object.assign(state, initialState())
  },
}

const actions = {
  async getServiceByInvoice ({ commit }, invoiceId) {
    commit('SET_INVOICE_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await amapi.makecall('renewalinvoice', { invoice_id: invoiceId })
      if (response.service_id) {
        return response.service_id
      }
      throw new Error(response.error || 'Invoice not found')
    } catch (e) {
      commit('SET_ERROR', e.message || 'Invalid invoice')
      throw e
    } finally {
      commit('SET_INVOICE_LOADING', false)
    }
  },
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export default module
